import {
  BatchRecordDoughBatch,
  CreateBatchRecordDoughBatchRequest
} from '../types/batchRecordDoughBatch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const batchRecordDoughBatchApiService = {
  /**
   * Fetch all batch record dough batches from the backend
   */
  fetchAllBatchRecordDoughBatches: async (): Promise<BatchRecordDoughBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-dough-batches`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch batch record dough batches');
      }

      return data.batchRecordDoughBatches;
    } catch (error) {
      console.error('Error fetching batch record dough batches from API:', error);
      throw error;
    }
  },

  /**
   * Fetch batch record dough batches by batch record ID
   */
  fetchBatchRecordDoughBatchesByBatchRecordId: async (batchRecordId: string): Promise<BatchRecordDoughBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-dough-batches/by-batch-record/${batchRecordId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch batch record dough batches');
      }

      return data.batchRecordDoughBatches;
    } catch (error) {
      console.error('Error fetching batch record dough batches by batch record ID from API:', error);
      throw error;
    }
  },

  /**
   * Create a new batch record dough batch
   */
  createBatchRecordDoughBatch: async (data: CreateBatchRecordDoughBatchRequest): Promise<BatchRecordDoughBatch> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-dough-batches`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();

      if (!responseData.success) {
        throw new Error(responseData.error || 'Failed to create batch record dough batch');
      }

      return responseData.batchRecordDoughBatch;
    } catch (error) {
      console.error('Error creating batch record dough batch:', error);
      throw error;
    }
  },

  /**
   * Delete a batch record dough batch by ID
   */
  deleteBatchRecordDoughBatch: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-dough-batches/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete batch record dough batch');
      }
    } catch (error) {
      console.error('Error deleting batch record dough batch:', error);
      throw error;
    }
  }
};
